/**
 * Operation flags for ImageEdit plugin
 */
// eslint-disable-next-line etc/no-const-enum
export var ImageEditOperation;
(function (ImageEditOperation) {
    /**
     * No operation
     */
    ImageEditOperation[ImageEditOperation["None"] = 0] = "None";
    /**
     * Resize image from corner ( horizontal and vertical resize)
     */
    ImageEditOperation[ImageEditOperation["CornerResize"] = 1] = "CornerResize";
    /**
     * Resize image from side ( either horizontal or vertical resize)
     */
    ImageEditOperation[ImageEditOperation["SideResize"] = 2] = "SideResize";
    /**
     * Image resize
     */
    ImageEditOperation[ImageEditOperation["Resize"] = 3] = "Resize";
    /**
     * Image rotate
     */
    ImageEditOperation[ImageEditOperation["Rotate"] = 4] = "Rotate";
    /**
     * Image resize and rotate
     */
    ImageEditOperation[ImageEditOperation["ResizeAndRotate"] = 7] = "ResizeAndRotate";
    /**
     * Image crop
     */
    ImageEditOperation[ImageEditOperation["Crop"] = 8] = "Crop";
    /**
     * All operations
     */
    ImageEditOperation[ImageEditOperation["All"] = 15] = "All";
})(ImageEditOperation || (ImageEditOperation = {}));
//# sourceMappingURL=ImageEditOperation.js.map